import React from 'react'
import classNames from 'classnames/bind'
import { USER_ROLES } from 'constants/user'
import { LINK_TO_INFO } from 'constants/links'
import { FEATURE_NAMES, BENEFIT_NAMES } from 'constants/dataNames'
import { Text as TextType } from 'hocs/localization'
import AccessWrapper from 'apps/AccessWrapper'
import Button from 'elements/Button'
import Text from 'elements/Text'
import { toCurrency } from 'utils/price'
import ComparePlansOption from './apps/ComparePlansOption'
import * as styles from './ComparePlans.scss'
import Tooltip from '../Tooltip'

const cx = classNames.bind(styles)

interface IProps {
  t: TextType,
  subscriptionPlans: any[],
  onSelect: (id: string) => void,
  onUpdatePlans: (plans) => void,
  benefits: any[],
  features: any[],
  groupedPlans: any[][],
  selectPlanOff?: USER_ROLES[],
  selectedPlanId?: string,
}

interface IState {
  plansState: any[],
  groupedPlansState: any[][],
}

const BENEFIT_ORDERS = [
  BENEFIT_NAMES.greatFor,
  BENEFIT_NAMES.unlimitedInk,
  BENEFIT_NAMES.prioritySupport,
]

const FEATURE_ORDERS = [
  FEATURE_NAMES.modes,
  FEATURE_NAMES.auto2SidePrinting,
  FEATURE_NAMES.borderlessPhotos,
  FEATURE_NAMES.autoDocumentFeeder,
  FEATURE_NAMES.ethernetConnection,
  FEATURE_NAMES.fax,
  FEATURE_NAMES.touchscreenPanel,
  FEATURE_NAMES.auto2SidedScanning,
  FEATURE_NAMES.wideFormatPrinting,
  FEATURE_NAMES.printSpeed,
  FEATURE_NAMES.paperTray,
  FEATURE_NAMES.wifiBandsSupported,
]

const OPTION_LABEL_BY_NAME = {
  [BENEFIT_NAMES.greatFor]: 'greatFor',
  [BENEFIT_NAMES.unlimitedInk]: 'unlimitedInk',
  [BENEFIT_NAMES.prioritySupport]: 'prioritySupport',
  [FEATURE_NAMES.modes]: 'modes',
  [FEATURE_NAMES.auto2SidePrinting]: 'auto2SidePrinting',
  [FEATURE_NAMES.borderlessPhotos]: 'borderlessPhotos',
  [FEATURE_NAMES.autoDocumentFeeder]: 'autoDocumentFeeder',
  [FEATURE_NAMES.ethernetConnection]: 'ethernetConnection',
  [FEATURE_NAMES.fax]: 'fax',
  [FEATURE_NAMES.touchscreenPanel]: 'touchscreenPanel',
  [FEATURE_NAMES.auto2SidedScanning]: 'auto2SidedScanning',
  [FEATURE_NAMES.wideFormatPrinting]: 'wideFormatPrinting',
  [FEATURE_NAMES.printSpeed]: 'printSpeed',
  [FEATURE_NAMES.paperTray]: 'paperTray',
  [FEATURE_NAMES.wifiBandsSupported]: 'wifiBandsSupported',
}

class ComparePlans extends React.Component<IProps, IState> {

  public state = {
    plansState: this.props.subscriptionPlans,
    benefitsState: this.props.benefits,
    featuresState: this.props.features,
    groupedPlansState: this.props.groupedPlans,
  }

  public static getDerivedStateFromProps (props, state) {
    return {
      plansState: props.subscriptionPlans,
    }
  }

  private onChangeCheckBox = (weight, e) => {
    const plansFromState = [...this.state.plansState]
    const plansFromGroup = plansFromState.filter(x => x.weight === weight)

    // exchange plans vivibility
    const firstGroupPlanVisibility = plansFromGroup[0].visible
    plansFromGroup[0].visible = plansFromGroup[1].visible
    plansFromGroup[1].visible = firstGroupPlanVisibility

    const benefitsFromState = [...this.state.benefitsState]
    const benefitsFromGroup = benefitsFromState.filter(x => x.weight === weight)

    // exchange benefits vivibility
    const firstGroupBenefitsVisibility = benefitsFromGroup[0].visible
    benefitsFromGroup[0].visible = benefitsFromGroup[1].visible
    benefitsFromGroup[1].visible = firstGroupBenefitsVisibility

    const featuresFromState = [...this.state.featuresState]
    const featuresFromGroup = featuresFromState.filter(x => x.weight === weight)

    // exchange features vivibility
    const firstGroupFeaturesVisibility = featuresFromGroup[0].visible
    featuresFromGroup[0].visible = featuresFromGroup[1].visible
    featuresFromGroup[1].visible = firstGroupFeaturesVisibility

    this.props.onUpdatePlans(plansFromState)
  }

  public render () {

    const {
      t,
      subscriptionPlans,
      groupedPlans,
      onSelect,
      benefits,
      features,
      selectPlanOff = [],
      selectedPlanId,
    } = this.props

    const { plansState, benefitsState, featuresState } = this.state
    const groupedPlansKeys = Object.keys(groupedPlans)
    const visiblePlans = plansState.filter(x => x.visible)

    return (

  <React.Fragment>
    <div className={styles.section}>
      <div className={styles.gutter}/>
      <div className={cx('card-group', styles.row)}>

      {groupedPlansKeys.map((key) => {

        return (
          <div key={groupedPlans[key][0].id} className={styles.card}>
            {plansState.filter(x => x.visible && x.weight === groupedPlans[key][0].weight)
            .map(({ id, name, productDescription, productImageUri, activationFee, price, hasAvailableDevices, weight }) => (
              <div key={id} className={styles.cardWrapper}>
                <div className={styles.columnContent}>
                  <h2 className={styles.name}>{name}</h2>
                  <h3 className={styles.productDescription}>{productDescription}</h3>
                  <div className={styles.image}>
                    <img src={productImageUri} alt={productDescription}/>
                  </div>
                  <h2 className={styles.price}>
                    {t('price', { price: toCurrency(price) })}<span className={styles.activationFeeText}>/mo</span>
                  </h2>

                  <div className={styles.activationFee}>
                    {groupedPlans[key].length > 1 && (
                      <div>
                        <input checked={plansState.find(x => x.id === groupedPlans[key][1].id).visible}
                               onChange={(e) => this.onChangeCheckBox(weight, e)} type='checkbox' />
                        <span className={styles.activationFeeText}>
                          {t('activationFee', { activationFee: toCurrency(groupedPlans[key][1].activationFee) })}
                          {groupedPlans[key].length > 1 && (
                            <Tooltip
                              id={`activation-tooltip-${id}`}
                              title={t('payLessTooltipHeader')}
                              content={t('payLessTooltipBody')}
                              position='bottom'
                            />
                          )}
                        </span>
                      </div>
                    )}
{/*                     {groupedPlans[key].length === 1 && (
                      <div>
                        <span className={styles.activationFeeText}>
                          No activation fee
                        </span>
                      </div>
                    )} */}
                  </div>

                </div>
                <AccessWrapper off={selectPlanOff}>
                  <Button
                    onClick={() => onSelect(id)}
                    size='small'
                    disabled={selectedPlanId === id}
                    fluid
                  >
                    <span className={styles.fullSelectButton}>{ hasAvailableDevices ? t('selectPlanButton') : t('notifyPlanButton')}</span>
                    <span className={styles.shortSelectButton}>{ hasAvailableDevices ? t('selectPlanButtonShort') : t('notifyPlanButtonShort')}</span>
                  </Button>
                </AccessWrapper>
              </div>
            ))}
          </div>
        )
      })}

      </div>
    </div>
    <h5 className={styles.sectionHeader}>{t('benefitsHeader')}</h5>
    <div className={cx('section', 'options', 'benefits')}>
      {BENEFIT_ORDERS.map(name => (
        <ComparePlansOption
          key={name}
          name={name}
          options={benefitsState}
          label={t(`names.${OPTION_LABEL_BY_NAME[name]}`)}
        />
      ))}
    </div>
    <div className={styles.separator}/>
    <h5 className={styles.sectionHeader}>{t('featuresHeader')}</h5>
    <div className={cx('section', 'options', 'features')}>
      {FEATURE_ORDERS.map(name => (
        <ComparePlansOption
          key={name}
          name={name}
          options={featuresState}
          label={t(`names.${OPTION_LABEL_BY_NAME[name]}`)}
        />
      ))}
    </div>
    <AccessWrapper off={selectPlanOff}>
      <div className={cx('section', 'selectButton')}>
        <div className={styles.gutter}/>
        <div className={styles.row}>
          {visiblePlans.map(({ id, hasAvailableDevices }) => (
            <div key={id} style={{ width: `${100 / visiblePlans.length - 2}%` }}>
              <div className={styles.columnContent}>
                <Button
                  onClick={() => onSelect(id)}
                  size='small'
                  disabled={selectedPlanId === id}
                  fluid
                >
                  <span className={styles.fullSelectButton}>{ hasAvailableDevices ? t('selectPlanButton') : t('notifyPlanButton')}</span>
                  <span className={styles.shortSelectButton}>{ hasAvailableDevices ? t('selectPlanButtonShort') : t('notifyPlanButtonShort')}</span>
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AccessWrapper>
    <div className={styles.actualSavings}>
      <Text size='xSmall'>
        <div>
          {t('home.actualSavings1')}
          <a href={LINK_TO_INFO} target='_blank' className={styles.link}>
            {t('home.link')}
          </a>
        </div>
        <div>{t('home.actualSavings2')}</div>
      </Text>
    </div>
  </React.Fragment>
    )
  }
}

export default ComparePlans
